import React, { KeyboardEvent } from 'react'
import { Box, InputAdornment, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'

import {
  NotionButton,
  NotionTextField,
} from '@/apps/latest/components/portal/notion'

interface SearchBoxProps {
  placeholder?: string
  value: string
  onChange: (value: string) => void
  onSearch: () => void
  buttonText?: string
  fullWidth?: boolean
  /** standard: input only (= button 非表示). outlined: input + button. */
  variant?: 'outlined' | 'standard'
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder = 'キーワードを入力',
  value,
  onChange,
  onSearch,
  buttonText = '検索',
  fullWidth = true,
  variant = 'outlined',
}) => {
  const handleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onSearch()
    }
  }

  const handleClear = () => {
    onChange('')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: fullWidth ? '100%' : 'auto',
      }}
    >
      <Box
        sx={{
          flex: fullWidth ? 1 : undefined,
          width: fullWidth ? '100%' : 280,
        }}
      >
        <NotionTextField
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          fullWidth={fullWidth}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
            endAdornment: value ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="入力をクリア"
                  onClick={handleClear}
                  edge="end"
                  size="small"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />
      </Box>
      {variant !== 'standard' && (
        <NotionButton variant="secondary" onClick={onSearch}>
          {buttonText}
        </NotionButton>
      )}
    </Box>
  )
}

export default SearchBox
